var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: { xs: 8, sm: 16, md: 24, lg: 32 } } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { "margin-right": "-35px" },
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label:
                              _vm.language[
                                "messageTemplatemanagement.templateCode"
                              ],
                            prop: "templateCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              disabled: _vm.disable,
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language[
                                  "messageTemplatemanagement.templateCode"
                                ]
                            },
                            model: {
                              value: _vm.model.templateCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "templateCode", $$v)
                              },
                              expression: "model.templateCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label:
                              _vm.language[
                                "messageTemplatemanagement.templateType"
                              ],
                            prop: "templateType"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              triggerChange: true,
                              dictCode: "msgType",
                              placeholder:
                                _vm.language["common.pleaseChoose"] +
                                _vm.language[
                                  "messageTemplatemanagement.templateType"
                                ]
                            },
                            on: { change: _vm.handleChangeTemplateType },
                            model: {
                              value: _vm.model.templateType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "templateType", $$v)
                              },
                              expression: "model.templateType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { "margin-right": "-35px" },
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label:
                              _vm.language[
                                "messageTemplatemanagement.templateName"
                              ],
                            prop: "templateName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language[
                                  "messageTemplatemanagement.templateName"
                                ]
                            },
                            model: {
                              value: _vm.model.templateName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "templateName", $$v)
                              },
                              expression: "model.templateName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: _vm.language["premission.applicationName"],
                            prop: "applicationCode"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                allowClear: "",
                                placeholder:
                                  _vm.language["column.pleaseChoose"] +
                                  _vm.language["premission.applicationName"],
                                disabled:
                                  _vm.actionType === "edit" ||
                                  _vm.$store.getters.application
                                    .applicationType !== "platform"
                              },
                              model: {
                                value: _vm.model.applicationCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "applicationCode", $$v)
                                },
                                expression: "model.applicationCode"
                              }
                            },
                            _vm._l(_vm.applicationList, function(
                              application,
                              index
                            ) {
                              return _c(
                                "a-select-option",
                                {
                                  key: index.toString(),
                                  attrs: { value: application.applicationCode }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(application.applicationName) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.useEditor
                ? _c(
                    "a-row",
                    { staticClass: "form-row", attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24, pull: "4" } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              staticStyle: {
                                "margin-left": "4px",
                                width: "126%"
                              },
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label:
                                  _vm.language[
                                    "messageTemplatemanagement.templateContent"
                                  ],
                                prop: "templateContent"
                              }
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language[
                                      "messageTemplatemanagement.templateContent"
                                    ],
                                  autosize: { minRows: 8, maxRows: 8 },
                                  maxLength: 800
                                },
                                model: {
                                  value: _vm.model.templateContent,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "templateContent", $$v)
                                  },
                                  expression: "model.templateContent"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.useEditor
                ? _c(
                    "a-row",
                    { staticClass: "form-row", attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24, pull: "4" } },
                        [
                          _c(
                            "a-form-item",
                            {
                              staticStyle: {
                                "margin-left": "4px",
                                width: "126%"
                              },
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label:
                                  _vm.language[
                                    "messageTemplatemanagement.templateContent"
                                  ],
                                prop: "templateContent"
                              }
                            },
                            [
                              _c("j-editor", {
                                model: {
                                  value: _vm.templateEditorContent,
                                  callback: function($$v) {
                                    _vm.templateEditorContent = $$v
                                  },
                                  expression: "templateEditorContent"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }